import React, { useState, useEffect } from 'react';

function getEndOfMonth() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
}

function getTimeRemaining(endDate) {
  const now = new Date();
  const diff = endDate - now;
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
}

function getMonthName() {
  return new Date().toLocaleString('en-IN', { month: 'long' });
}

export default function MysteryGiftBanner() {
  const [timeLeft, setTimeLeft] = useState(getTimeRemaining(getEndOfMonth()));
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const endOfMonth = getEndOfMonth();
    const interval = setInterval(() => { setTimeLeft(getTimeRemaining(endOfMonth)); }, 1000);
    return () => clearInterval(interval);
  }, []);

  if (dismissed) return null;

  return (
    <div className="rt-gift-banner" data-testid="rt-gift-banner">
      <div className="rt-gift-banner-inner">
        <div className="rt-gift-banner-content">
          <span className="rt-gift-emoji">🎁</span>
          <div className="rt-gift-text">
            <strong>Every month, 100 best verdicts win a mystery gift.</strong>
            <span className="rt-gift-deadline">Submit yours before {getMonthName()} ends!</span>
          </div>
        </div>
        <div className="rt-countdown">
          <div className="rt-countdown-item"><span className="rt-countdown-num">{timeLeft.days}</span><span className="rt-countdown-label">days</span></div>
          <span className="rt-countdown-sep">:</span>
          <div className="rt-countdown-item"><span className="rt-countdown-num">{String(timeLeft.hours).padStart(2, '0')}</span><span className="rt-countdown-label">hrs</span></div>
          <span className="rt-countdown-sep">:</span>
          <div className="rt-countdown-item"><span className="rt-countdown-num">{String(timeLeft.minutes).padStart(2, '0')}</span><span className="rt-countdown-label">min</span></div>
          <span className="rt-countdown-sep">:</span>
          <div className="rt-countdown-item"><span className="rt-countdown-num">{String(timeLeft.seconds).padStart(2, '0')}</span><span className="rt-countdown-label">sec</span></div>
        </div>
        <button onClick={() => setDismissed(true)} className="rt-gift-dismiss" aria-label="Dismiss banner" data-testid="rt-gift-dismiss">✕</button>
      </div>
    </div>
  );
}
